var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { FieldFailureDashboard, getDashboardCount } from "../../services/apiCalls";
import dayjs from "dayjs";
import { DynamicFormBuilderContainer } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { DesktopTabComponent } from "../../../../components/molecules/desktopTabComponent";
import { AreaFieldReportsKeys } from "../../services/entity";
import { PSGDashboard } from "./DashboardGraphView";
import { useMediaQuery } from "@mui/material";
export var DashboardComp = function () {
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var DashboardTab = [{
            type: FormItemTypes.ContainerItem,
            name: "",
            columnSize: 12,
            spacing: 0,
            justifyContent: "space-between",
            gap: "16px",
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    columnSize: 6,
                    xs: 12,
                    sm: 6,
                    md: 6,
                    lg: 6,
                    spacing: 0,
                    width: "auto",
                    sx: {
                        overflowX: "auto",
                        overflowY: "visible",
                        flexWrap: "nowrap",
                        width: "100%",
                        scrollbarWidth: "none"
                    },
                    position: "static",
                    elements: [{
                            type: FormItemTypes.CardComponent,
                            name: "",
                            columnSize: 0,
                            sx: {
                                padding: "6px",
                                bgcolor: "secondary.100",
                                borderColor: "secondary.200"
                            },
                            elements: []
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    value: null,
                    xs: 12,
                    sm: 6,
                    md: 4,
                    lg: 4,
                    alignItems: "center",
                    spacing: 0,
                    py: 1,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: "",
                            label: "DateRange",
                            columnSize: 0,
                            labelTypographyProps: {
                                fontSize: "sm",
                                fontWeight: "medium"
                            },
                            sx: {
                                marginRight: "10px"
                            },
                            //   return {
                            //     type: FormItemTypes.Typography,
                            //     name: "DateRange",
                            //     children: `${dayjs(state?.FromDate).format(
                            //       "DD MMMM YYYY"
                            //     )} to ${dayjs(state?.ToDate).format("DD MMMM YYYY")}`,
                            //   };
                            // },
                            setFieldProps: function (state, currentValue) {
                                console.log("state from typography", state);
                                var today = dayjs();
                                var startOfYear = dayjs().startOf("year");
                                var fromDate = state !== null && state !== void 0 && state.FromDate ? dayjs(state === null || state === void 0 ? void 0 : state.FromDate) : startOfYear;
                                var toDate = state !== null && state !== void 0 && state.ToDate ? dayjs(state === null || state === void 0 ? void 0 : state.ToDate) : today;
                                var fromDateFormatted = fromDate.format("DD MMM YYYY");
                                var toDateFormatted = toDate.format("DD MMM YYYY");
                                return {
                                    type: FormItemTypes.Typography,
                                    name: "DateRange",
                                    children: "".concat(fromDateFormatted, " to ").concat(toDateFormatted)
                                };
                            }
                        }, {
                            type: FormItemTypes.SearchSelect,
                            name: "DataRange",
                            placeholder: "Select Data Range",
                            columnSize: true,
                            options: [{
                                    id: "weekToDate",
                                    Name: "Week to Date"
                                }, {
                                    id: "MonthToDate",
                                    Name: "Month to Date"
                                }, {
                                    id: "PreviousMonth",
                                    Name: "Previous Month"
                                }, {
                                    id: "YearToDate",
                                    Name: "Year to Date"
                                }, {
                                    id: "PreviousYear",
                                    Name: "Previous Year"
                                }, {
                                    id: "custom",
                                    Name: "Custom"
                                }],
                            setFormState: function (formValue, currentValue) { return __awaiter(void 0, void 0, void 0, function () {
                                var date, updatedState;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            date = getDateRange(currentValue);
                                            updatedState = _objectSpread(_objectSpread({}, formValue), {}, {
                                                DataRange: currentValue,
                                                FromDate: date.fromISO,
                                                ToDate: date.toISO,
                                                ShowCalendar: (currentValue === null || currentValue === void 0 ? void 0 : currentValue.Name) === "Custom"
                                            });
                                            return [4 /*yield*/, getDashboardCount({
                                                    request: {
                                                        DataRange: currentValue === null || currentValue === void 0 ? void 0 : currentValue.id,
                                                        FromDate: date.fromISO,
                                                        ToDate: date.toISO
                                                    }
                                                })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/, updatedState];
                                    }
                                });
                            }); }
                        }]
                }]
        }, {
            type: FormItemTypes.Stack,
            name: "",
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Custom,
                    name: "",
                    columnSize: 12,
                    element: PSGDashboard
                }]
        }];
    var date = getDateRange({
        Name: "Year to Date"
    });
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, null), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: DashboardTab,
        getFormAPI: FieldFailureDashboard,
        mode: "edit",
        getKey: AreaFieldReportsKeys.getDashboard,
        getRequest: {
            DataRange: "YearToDate",
            FromDate: date.fromISO,
            ToDate: date.toISO
        },
        gridProps: {
            spacing: 0
        }
        // onChange={(e, { state, field, value }) => {
        //     handlePagingUpdate(state);
        // }}
    }));
};
function getDateRange(option) {
    var _fromDate, _toDate;
    var today = new Date();
    var fromDate, toDate = new Date(today);
    switch (option === null || option === void 0 ? void 0 : option.Name) {
        case "Week to Date":
            fromDate = new Date(today);
            fromDate.setDate(today.getDate() - today.getDay() + 1);
            break;
        case "Month to Date":
            fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
            break;
        case "Previous Month":
            fromDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
            toDate = new Date(today.getFullYear(), today.getMonth(), 0);
            break;
        case "Year to Date":
            fromDate = new Date(today.getFullYear(), 0, 1);
            break;
        case "Previous Year":
            if (today.getMonth() + 1 < 4) {
                fromDate = new Date(today.getFullYear() - 2, 3, 1);
                toDate = new Date(today.getFullYear() - 1, 2, 31);
            }
            else {
                fromDate = new Date(today.getFullYear() - 1, 3, 1);
                toDate = new Date(today.getFullYear(), 2, 31);
            }
            break;
        case "Custom":
        default:
            return {
                from: null,
                to: null
            };
    }
    var fromISO = (_fromDate = fromDate) === null || _fromDate === void 0 ? void 0 : _fromDate.toISOString();
    var toISO = (_toDate = toDate) === null || _toDate === void 0 ? void 0 : _toDate.toISOString();
    return {
        fromISO: fromISO,
        toISO: toISO
    };
}
